import type { FC } from 'react';
import router from 'next/router';
import { getFilterToolbarAnalyticsEvents, selectUserIsAuthenticated } from '@mwl/core-lib';
import { Tabs } from '@mwl/ui';
import FilledStarIcon from '@public/assets/common/icons/favorites.svg';
import OutlinedStarIcon from '@public/assets/common/icons/favoritesBold.svg';
import { Tab } from '@/components/Tab/Tab';
import { routes } from '@/constants';
import { useIsCyberSportPage, useTypedSelector } from '@/hooks';
import { AdditionalModeFilter } from './components/AdditionalModeFilter';
import { useMobileFilterElements } from './MobileModeFilter.hooks';
import type { MobileModeFilterProps } from './MobileModeFilter.types';
import styles from './MobileModeFilter.module.scss';
const MobileModeFilter: FC<MobileModeFilterProps> = ({
  className
}) => {
  const isCyberSportPage = useIsCyberSportPage();
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const {
    top,
    live,
    pregame,
    favorites
  } = useMobileFilterElements();
  return <Tabs className={cn(styles.root, className)} data-sentry-element="Tabs" data-sentry-component="MobileModeFilter" data-sentry-source-file="MobileModeFilter.tsx">
      {!isCyberSportPage && <Tab className={styles.tab} active={top.isActive} as="link" href={top.href} label={<span className={styles.labelWrapper}>{top.text}</span>} shallow={router.pathname === routes.sport.home} analytics={getFilterToolbarAnalyticsEvents({
      sectionName: top.sectionName,
      isActive: top.isActive,
      text: top.text,
      href: top.href
    })} />}
      <Tab className={styles.tab} active={live.isActive} as="link" href={live.href} label={<span className={styles.labelWrapper}>{live.text}</span>} analytics={getFilterToolbarAnalyticsEvents({
      sectionName: live.sectionName,
      isActive: live.isActive,
      text: live.text,
      href: live.href
    })} data-sentry-element="Tab" data-sentry-source-file="MobileModeFilter.tsx" />
      <Tab className={styles.tab} active={pregame.isActive} as="link" href={pregame.href} label={<span className={styles.labelWrapper}>{pregame.text}</span>} analytics={getFilterToolbarAnalyticsEvents({
      sectionName: pregame.sectionName,
      isActive: pregame.isActive,
      text: pregame.text,
      href: pregame.href
    })} data-sentry-element="Tab" data-sentry-source-file="MobileModeFilter.tsx" />
      {isAuth && <Tab className={styles.tab} as="link" href={favorites.href} active={favorites.isActive} label={<span className={styles.favoritesFilterLabel}>
              {favorites.isActive ? <FilledStarIcon className={cn(styles.favoritesFilterIcon, styles.active)} /> : <OutlinedStarIcon className={styles.favoritesFilterIcon} />}
              <span className={styles.labelWrapper}>{favorites.text}</span>
            </span>} analytics={getFilterToolbarAnalyticsEvents({
      sectionName: favorites.sectionName,
      isActive: favorites.isActive,
      text: favorites.text,
      href: favorites.href
    })} />}
      {!isCyberSportPage && <AdditionalModeFilter />}
    </Tabs>;
};
export { MobileModeFilter };